// App.js
import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './Home';
import AboutUs from './Pages/AboutUs';
import ContactUs from './Pages/ContactUs';
import Plans from './Pages/Plans';
import Careers from './Pages/Careers';
import TermsConditions from './Pages/SubPages/TermsConditions';
import PrivacyPolicy from './Pages/SubPages/PrivacyPolicy';
import CompanyDoc from './Pages/SubPages/CompanyDoc';
import Services from './Pages/Services';

const routes = [
  // { path: "/dash", element: <Protected Component={Dashboard} requiredPermission="s_view_dashboard" /> },
  { path: "/", element: <Home /> },
  { path: "/aboutUs", element: <AboutUs /> },
  { path: "/contactUs", element: <ContactUs /> },
  { path: "/plans", element: <Plans /> },
  { path: "/careers", element: <Careers /> },
  { path: "/services", element: <Services /> },
  { path: "/privacyPolicy", element: <PrivacyPolicy /> },
  { path: "/termsConditions", element: <TermsConditions /> },
  { path: "/CompanyDoc", element: <CompanyDoc /> },

];


function App() {

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };


  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
